import { SvgIcon } from '@/components';
import { useTranslation } from 'react-i18next';

import styles from './VerifiedCompanyOnly.module.sass';

const VerifiedCompanyOnly = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.verified}>
      <div className={styles.title}>
        <SvgIcon name="verified" className={styles.icon} />
        <span className={styles.text}>Verified Company only</span>
      </div>
      <div className={styles.description}>
        {t('translation.tariff_company_only')}
      </div>
    </div>
  );
};

export default VerifiedCompanyOnly;
